import React from 'react'
import {
  Toolbar
} from '@material-ui/core'
import { NavigationBar } from './navigation/navigation'

function Page (props) {
  return (
    <div>
      {
        props.isEvaluator &&
          <React.Fragment>
            <Toolbar disableGutters style={{marginBottom: '30px'}}>
              <NavigationBar />
            </Toolbar>
          </React.Fragment>
      }
      {props.children}
    </div>
  )
}

export default Page
